import { api } from "./api";
import {
  ComplaintCreate,
  ComplaintFull,
  ComplaintUpdate,
  IssueRecordCreate,
  IssueRecordUpdate,
  RMARequestDataBatchCreateFull,
  RMARequestDataCreate,
} from "../types/qualityRecordTypes";
import {
  BaseRecordCreateResponse,
  BaseUpdateResponseSchemaV2,
  IdAsUUID,
  MessageResponse,
} from "../types/common/commonTypes";

/**
 * Inventory Management Service
 *
 * Provides complete integration with all 12 inventory management API endpoints:
 * - Core lot management (CRUD operations)
 * - FIFO allocation engine
 * - Real-time availability tracking
 * - Lot shipping and movement
 * - Comprehensive inventory summaries
 *
 * Auto-generation: Lot numbers are auto-generated by backend (YY-###### format)
 * Example: 24-000001, 24-000002, etc. (resets annually)
 */
const qual_base = "/quality";
const cf_base = `${qual_base}/customer-feedback`;
export const complaintService = {
  create: async (data: ComplaintCreate): Promise<ComplaintFull> => {
    const response = await api.post(`${cf_base}/`, data);
    return response.data;
  },
  update: async (
    id: string,
    data: ComplaintUpdate,
  ): Promise<BaseUpdateResponseSchemaV2> => {
    const response = await api.put(`${cf_base}/update/${id}`, data);
    return response.data;
  },
  getById: async (id: string): Promise<ComplaintFull> => {
    const response = await api.get(`${cf_base}/${id}`);
    return response.data;
  },
  postProcess: async (id: string): Promise<MessageResponse> => {
    const response = await api.put(`${cf_base}/postprocess/${id}`);
    return response.data;
  },
  updateCFNum: async (id: string, cf_num: string): Promise<MessageResponse> => {
    const response = await api.put(`${cf_base}/update_cf_num/${id}`, {
      cf_num: cf_num,
    });
    return response.data;
  },
  approve: async (id: string): Promise<MessageResponse> => {
    const response = await api.put(`${cf_base}/approve/${id}`);
    return response.data;
  },
};

const rma_base = `${qual_base}/returned-material`;
export const rmaService = {
  create: async (
    data: RMARequestDataCreate,
  ): Promise<BaseRecordCreateResponse> => {
    const response = await api.post(`${rma_base}/`, data);
    return response.data;
  },
  createBatch: async (
    data: RMARequestDataBatchCreateFull,
  ): Promise<BaseRecordCreateResponse> => {
    const response = await api.post(`${rma_base}/`, data);
    return response.data;
  },
};

const issue_base = `{qual_base}/issue-tracking`;
export const issueTrackerService = {
  create: async (data: IssueRecordCreate): Promise<MessageResponse> => {
    const response = await api.post(`${issue_base}/`, data);
    return response.data;
  },
  update: async (
    data: IssueRecordUpdate,
    id: IdAsUUID,
  ): Promise<MessageResponse> => {
    const response = await api.put(`${issue_base}/${id}`, data);
    return response.data;
  },
};
